import {material} from "./materials";
import {link} from"./links"
import {over} from "./over";
import {video} from "./videos";

export const geographyMaterials = [
    {
        id: 1,
        menuItemId: 6,
        materials: material,
        links: link,
        video: video,
        tests: over
    }
]
